import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faInfoCircle,
  faEllipsisH,
  faUndo,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCheckCircle as farFaCheckCircle,
  faCalendar,
  faEye,
  faHourglass,
  faFile,
  faTrashAlt,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faTrashAlt,
  faFile,
  farFaCheckCircle,
  faInfoCircle,
  faTimes,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCalendar,
  faEye,
  faUndo,
  faEllipsisH,
  faHourglass
);
